<div
  class="dashboard-wrapper md:container md:mx-auto px-4 pt-2 pb-[4rem]"
  id="dashboard__container"
>
  <div
    class="font-edenred md:container md:mx-auto pt-[3rem] text-2xl md:text-4xl text-grayscale-heavy"
  >
    <span class="salutation text-black font-bold" id="dashboard__salutation"
      >{{ i18Cmp + ".salutation" | transloco }}
      {{ userStore.partner_name }},</span
    >
    <span class="font-bold ml-[10px]">{{
      i18Cmp + ".intro_message" | transloco
    }}</span>
    <ed-tooltip
      class="ml-[10px]"
      tooltip="{{ i18Cmp + '.intro_description_tooltip' | transloco }}"
      position="bottom"
      id="dashboard__intro-tooltip"
    >
      <mat-icon svgIcon="exclamation-circle" class="stroke-blue-30"></mat-icon>
    </ed-tooltip>
  </div>

  @if (
    ffs.invoices() &&
    userStore.digitalInvoicesBannerActive() &&
    !userStore.hideInvoiceBannerOnDashboard() &&
    !confirmSwitchBannerClosed
  ) {
    <div class="pt-[3rem]">
      <er-digital-invoice-consent
        (closeBanner)="onCloseBanner()"
      ></er-digital-invoice-consent>
    </div>
  }

  <div class="pt-[3rem] w-full md:w-[526px] mb-4">
    <label
      class="text-grayscale-medium text-xs font-bold pl-[12px]"
      for="timePeriod"
      >{{ i18CmpTimePeriodDropdown + ".label" | transloco }}</label
    >
    <ng-select
      class="er-select"
      bindLabel="name"
      [items]="timePeriod"
      [ngModel]="dashboardStore.selectedTimePeriod()"
      [multiple]="false"
      [searchable]="false"
      [clearable]="false"
      (change)="onTimePeriodChange($event)"
      id="dashboard__time-period"
    >
      <ng-template ng-option-tmp let-item="item">
        {{ item.name | transloco }}
      </ng-template>

      <ng-template ng-label-tmp let-item="item">
        {{ item.name | transloco }}
      </ng-template>
    </ng-select>
  </div>

  <div
    class="bg-white p-4 rounded-2xl mb-4 shadow-md"
    id="dashboard__info-container"
  >
    <div class="flex flex-col items-start">
      <div class="font-edenred text-grayscale-heavy text-[1.5rem] font-bold">
        {{ i18CmpTotalPerformance + ".title" | transloco }}
      </div>
      <div class="font-ubuntu font-normal text-base text-grayscale-heavy">
        {{ dashboardStore.explanationMessage() | transloco }}
      </div>
    </div>
    @if (userStore.isPlusStation()) {
      <er-plus-performance-items
        (mouseenter)="onMouseEnter('TOTAL_PERFORMANCE')"
        (mouseleave)="onMouseLeave('TOTAL_PERFORMANCE')"
      ></er-plus-performance-items>
    } @else {
      <er-fuel-performance-items
        (mouseenter)="onMouseEnter('TOTAL_PERFORMANCE')"
        (mouseleave)="onMouseLeave('TOTAL_PERFORMANCE')"
      ></er-fuel-performance-items>
    }
  </div>

  <div class="flex gap-4 my-[2rem] w-full box-border flex-col lg:flex-row">
    <div
      class="w-full lg:w-[calc(75%-1rem)] bg-white shadow-md rounded-2xl p-4"
      (mouseenter)="onMouseEnter('TOTAL_VOLUMES')"
      (mouseleave)="onMouseLeave('TOTAL_VOLUMES')"
      id="dashboard__stacked-bar-chart"
    >
      @if (userStore.isPlusStation()) {
        <er-stacked-bar-chart
          class="w-full"
          [config]="dashboardStore.plusInvoicedTransactionConfig()"
          [labels]="totalVolumesStackBarChartLabels"
        ></er-stacked-bar-chart>
      } @else {
        <er-stacked-bar-chart
          class="w-full"
          [config]="dashboardStore.totalVolumesStackBarChartConfig()"
          [labels]="totalVolumesStackBarChartLabels"
        ></er-stacked-bar-chart>
      }
    </div>
    @let fuelVolumesConfig =
      dashboardStore.fuelVolumeOverviewDonutChartConfig();
    <div
      class="w-full lg:w-1/4 bg-white shadow-md rounded-2xl p-4"
      (mouseenter)="onMouseEnter('FUEL_VOLUME_OVERVIEW')"
      (mouseleave)="onMouseLeave('FUEL_VOLUME_OVERVIEW')"
      id="dashboard__fuel-volume-overview"
    >
      @if (userStore.isPlusStation()) {
        <div class="text-2xl font-bold font-edenred text-grayscale-heavy">
          {{ i18CmpPlusCustomerLocationChart + ".title" | transloco }}
        </div>
        <div class="flex h-full pt-4">
          <er-donut-chart
            class="w-full"
            [config]="dashboardStore.plusCustomerLocationConfig()"
          ></er-donut-chart>
        </div>
      } @else if (fuelVolumesConfig.labels) {
        <div class="text-2xl font-bold font-edenred text-grayscale-heavy">
          {{ i18CmpFuelVolumeOverviewChart + ".title" | transloco }}
        </div>
        <div class="flex h-full pt-4">
          <er-donut-chart
            class="w-full"
            [config]="fuelVolumesConfig"
          ></er-donut-chart>
        </div>
      }
    </div>
  </div>

  @if (!userStore.isPlusStation()) {
    <div
      class="table-wrapper bg-white p-4 rounded-2xl mb-8 shadow-md"
      (mouseenter)="onMouseEnter('LOCATION_PERFORMANCE')"
      (mouseleave)="onMouseLeave('LOCATION_PERFORMANCE')"
      id="dashboard__location-performance"
    >
      <div
        class="flex justify-between mb-[32px] location-performance-container items-center"
      >
        <h1
          class="font-edenred text-grayscale-heavy text-[1.5rem] font-bold location-performance-title"
        >
          {{ "dashboard.location_performance.title" | transloco }}
        </h1>

        <button
          ed-button
          [disabled]="!dashboardStore.stationPerformanceIds().length"
          edType="primary"
          class="w-[200px] download-file"
          routerLink="new-location"
          (click)="dashboardStore.downloadPerformanceFile()"
          id="dashboard__download-performance-file"
        >
          <mat-icon
            [svgIcon]="'download'"
            class="w-6 h-6 text-red-100 download-file-icon"
          />
          Download file
        </button>
      </div>

      <er-dashboard-filters
        (toggleColumnVisibility)="toggleColumnVisibility($event)"
        (filterData)="filterDataByName($event)"
        id="dashboard__filters"
      />
      <er-location-performance-list
        id="dashboard__er-location-performance-list"
      />
    </div>
  }
</div>
